const repository: { userBogoOfferEligible: boolean | undefined } = {
  userBogoOfferEligible: undefined,
}

export const forceUpdateUserBogoOfferEligible = (value: boolean) => {
  repository.userBogoOfferEligible = value
}

export const getUserBogoOfferEligible = () => repository.userBogoOfferEligible

export const clearRepository = () => {
  delete repository.userBogoOfferEligible
}
